<template>
  <v-panel class="devices-select">
    <template v-slot:header>
      <h2>
        <v-icon name="cpu"></v-icon>
        {{ $t('Select Devices') }}
      </h2>
    </template>

    <template v-slot:default>
      <table class="table">
        <thead>
          <tr>
            <th class="action">
              <v-checkbox :value="areAllDevicesSelected" @change="toggleSelectedDevices"></v-checkbox>
            </th>
            <th>{{ $t('Name') }}</th>
            <th>{{ $t('Revision') }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(device, index) in devices" :key="index">
            <td>
              <v-checkbox :value="isDeviceSelected(device)" @change="toggleDevice(device, $event)"></v-checkbox>
            </td>
            <td>{{ device.name }}</td>
            <td>{{ device.type.revisionNo }}</td>
          </tr>
        </tbody>
      </table>
    </template>

    <template v-slot:footer>
      <ul class="actions flex flex-center">
        <li>
          <button class="success" :disabled="!hasSelectedDevices" @click="selectDevices">
            {{ $t('Select') }}
          </button>
        </li>
      </ul>
    </template>
  </v-panel>
</template>

<script lang="ts" setup>
import { computed, ref } from 'vue'
import { $t } from '/@/i18n'
import { EthercatDevice } from '/@/shared/entities/EthercatDevice'

interface Props {
  devices?: EthercatDevice[] | null
}

interface Emits {
  (e: 'select-devices', devices: EthercatDevice[]): void
}

const props = withDefaults(defineProps<Props>(), {
  devices: null,
})

const emit = defineEmits<Emits>()

const selectedDevices = ref<EthercatDevice[]>([])

const hasSelectedDevices = computed(() => selectedDevices.value.length > 0)

const areAllDevicesSelected = computed(() => {
  if (!props.devices) {
    return false
  }

  return selectedDevices.value.length === props.devices.length
})

const isDeviceSelected = (device: EthercatDevice) => {
  return selectedDevices.value.includes(device)
}

const toggleDevice = (device: EthercatDevice, event: Event) => {
  const checkbox = event.target as HTMLInputElement

  if (checkbox.checked) {
    selectedDevices.value.push(device)
  } else {
    selectedDevices.value.splice(selectedDevices.value.indexOf(device), 1)
  }
}

const toggleSelectedDevices = (event: Event) => {
  const checkbox = event.target as HTMLInputElement

  if (!props.devices) {
    return
  }

  if (!checkbox.checked) {
    selectedDevices.value = []
  } else {
    selectedDevices.value = [...props.devices]
  }
}

const selectDevices = () => {
  emit('select-devices', selectedDevices.value)
}
</script>

<style src="./style.css"></style>
